import { call, delay, put, takeLatest, cancelled } from 'redux-saga/effects';
import {
  RECONSIDERATION_PENDING_BY_VOLUME_REQUEST,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST,
  RECONSIDERATION_DETAILS_REQUEST,
  RECONSIDERATION_DETAILS_SUCCESS,
  RECONSIDERATION_DETAILS_FAILURE,
  RECONSIDERATIONS_DETAILS_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE,
} from '../../../actions/actionTypes';
import * as actions from  '../../../actions/Reimbursement/reconsiderationAction';
const {
  fetchReconsiderationVolumeDataSuccess,
  fetchReconsiderationVolumeDataError,
  fetchReconsiderationVolumeDataLoading,
  fetchReconsiderationAverageDataLoading,
  fetchReconsiderationAverageDataSuccess,
  fetchReconsiderationAverageDataError,
} = actions;
import {
  getReconsiderationPendingVolData,
  getReconsiderationAverageData,
  getReconsiderationOutcomeReasonsData,
  getOutcomeSubmissionReasons,
  getReconsiderationDetails,
  getReconsiderationData,
} from '@src/middleware/services/reimbusement/reconsideration/reconsideration.service';

import {
  setRequestError,
  setRequestLoading,
  setRequestSuccess,
} from '@src/middleware/actions/common/common.actions';
import { reimbursementReconsiderationsStateKeys } from '@src/CommonComponents/constant/constant';
import { reimbursementPollingStarted, reimbursementPollingCompleted, reimbursementPollingError } from '@src/middleware/actions/Reimbursement/reiumbursementTabDataAction';
import { checkAppealsBulkFlow } from '@src/utility/createStorage';

const getServiceMethod: any = (key: string) => {
  switch (key) {
    case reimbursementReconsiderationsStateKeys.reconsiderationsDetailsData:
      return getReconsiderationData;
    default:
      return getReconsiderationData;
  }
};

export function* getReconPendingData(action: any) {
  const correlationId = `getReconPendingData-${Date.now()}`;
  try {
    yield put(fetchReconsiderationVolumeDataLoading(true));
    if (action?.highVolumeTinFlag) {
      yield put(reimbursementPollingStarted(correlationId));
    }
    const response = yield call(
      getReconsiderationPendingVolData,
      action?.payload,
      action?.highVolumeTinFlag
    );
    if (action?.highVolumeTinFlag && response && parseInt(response?.StatusCode) === 200) {
      yield put(reimbursementPollingCompleted(correlationId));
      yield put(fetchReconsiderationVolumeDataLoading(false));
      yield put(fetchReconsiderationVolumeDataSuccess(response));
    } else {
      yield put(fetchReconsiderationVolumeDataLoading(false));
      yield put(fetchReconsiderationVolumeDataSuccess(response));
    }
  } catch (error) {
    yield put(fetchReconsiderationVolumeDataError(error));
    yield put(fetchReconsiderationVolumeDataLoading(false));
    if (action?.highVolumeTinFlag) {
      yield put(reimbursementPollingError(error));
      yield put(reimbursementPollingCompleted(correlationId));
    }
  } finally {
    if (yield cancelled()) {
      yield put(fetchReconsiderationVolumeDataLoading(false));
      if (action?.highVolumeTinFlag) {
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }
  }
}

export function* getReconAverageData(action: any) {
  const correlationId = `getReconAverageData-${Date.now()}`;
  try {
    yield put(fetchReconsiderationAverageDataLoading(true));
    if (action?.highVolumeTinFlag) {
      yield put(reimbursementPollingStarted(correlationId));
    }
    const response = yield call(
      getReconsiderationAverageData,
      action?.payload,
      action?.highVolumeTinFlag
    );

    if (action?.highVolumeTinFlag && response && parseInt(response?.StatusCode) === 200) {
      yield put(reimbursementPollingCompleted(correlationId));
      yield put(fetchReconsiderationAverageDataLoading(false));
      yield put(fetchReconsiderationAverageDataSuccess(response));
    } else {
      yield put(fetchReconsiderationAverageDataLoading(false));
      yield put(fetchReconsiderationAverageDataSuccess(response));
    }
  } catch (error) {
    yield put(fetchReconsiderationAverageDataError(error));
    yield put(fetchReconsiderationAverageDataLoading(false));
    if (action?.highVolumeTinFlag) {
      yield put(reimbursementPollingError(error));
      yield put(reimbursementPollingCompleted(correlationId));
    }
  } finally {
    if (yield cancelled()) {
      yield put(fetchReconsiderationAverageDataLoading(false));
      if (action?.highVolumeTinFlag) {
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }
  }
}

export function* getOutcomeReasons(action: any) {
  try {
    const response = yield call(
      getReconsiderationOutcomeReasonsData,
      action?.payload
    );

    if (response && parseInt(response?.StatusCode) === 200) {
      const sortedData =
        response?.Data?.sort((a: any, b: any) => {
          if (
            b.ReconConclusionReasonPercentage !==
            a.ReconConclusionReasonPercentage
          ) {
            return (
              b.ReconConclusionReasonPercentage -
              a.ReconConclusionReasonPercentage
            );
          }
          return b.ReconConclusionReasonVolume - a.ReconConclusionReasonVolume;
        }) || [];

      //  delay(3000); // Simulating a delay of 3 seconds
        yield put({
          type: RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS,
          payload: sortedData,
        });
    } else {
      yield put({
        type: RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE,
        payload: response?.Message || 'Failed to fetch outcome volume data',
      });
    }
  } catch (error) {
    yield put({
      type: RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE,
      payload: error,
    });
  } finally {

  }
}

export function* getSubmissionReasons(action: any) {
  try {
    const response = yield call(getOutcomeSubmissionReasons, action?.payload);
    if (response && parseInt(response?.StatusCode) === 200) {
      const sortedData =
        response?.Data?.sort((a: any, b: any) => {
          if (
            b.ReconRequestReasonPercentage !== a.ReconRequestReasonPercentage
          ) {
            return (
              b.ReconRequestReasonPercentage - a.ReconRequestReasonPercentage
            );
          }
          return b.ReconRequestReasonVolume - a.ReconRequestReasonVolume;
        }) || [];


       yield put({
          type: RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS,
          payload: sortedData,
        });
    } else {
      yield put({
        type: RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE,
        payload:
          response?.Message || 'Failed to fetch submissions reasons data',
      });
    }
  } catch (error) {
    yield put({
      type: RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE,
      payload: error,
    });
  } finally {

  }
}

export function* getReconsiderationDetailsData(action: any) {
  try {
    const response = yield call(getReconsiderationDetails, action?.payload);
    if (response && parseInt(response?.StatusCode) === 200) {

      yield put({
        type: RECONSIDERATION_DETAILS_SUCCESS,
        payload: response?.Data || {},
      });
    } else {
      yield put({
        type: RECONSIDERATION_DETAILS_FAILURE,
        payload: response?.Message || 'Failed to fetch reconsideration details',
      });
    }
  } catch (error) {
    yield put({
      type: RECONSIDERATION_DETAILS_FAILURE,
      payload: error,
    });
  }
}

export function* fetchReconsiderationsData(action: any) {
  const correlationId = `fetchReconsiderationsData-${Date.now()}`;
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));
    if (checkAppealsBulkFlow()) {
      yield put(reimbursementPollingStarted(correlationId));
    }
    const response = yield call(getServiceMethod(key), payload);


    if (response?.status === false) {
      yield put(setRequestLoading(false, loadingKey));
      yield put(setRequestError(true, errorKey));
    } else if (response && parseInt(response?.StatusCode) === 200) {
      yield put(setRequestSuccess(response?.Data, key));
      if (checkAppealsBulkFlow()) {
        yield put(reimbursementPollingCompleted(correlationId));
      }
      yield put(setRequestLoading(false, loadingKey));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
    if (checkAppealsBulkFlow()) {
      yield put(reimbursementPollingCompleted(correlationId));
    }
  } finally {
    if (yield cancelled()) {
      yield put(setRequestLoading(false, loadingKey));
      if (checkAppealsBulkFlow()) {
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }
  }
}

export function* reconsiderSaga() {
  yield takeLatest(
    RECONSIDERATION_PENDING_BY_VOLUME_REQUEST,
    getReconPendingData
  );
  yield takeLatest(
    RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST,
    getReconAverageData
  );
  yield takeLatest(
    RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST,
    getOutcomeReasons
  );
  yield takeLatest(
    RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST,
    getSubmissionReasons
  );
  yield takeLatest(
    RECONSIDERATION_DETAILS_REQUEST,
    getReconsiderationDetailsData
  );
  yield takeLatest(
    RECONSIDERATIONS_DETAILS_DATA_REQUEST,
    fetchReconsiderationsData
  );
}
